'use strict';

export default class CityInterventionsBlock {
  constructor(options) {
    console.log('CityInterventionsBlock module');

    const defaults = {
      elemDispatcher: ".cityInterventionsBlock__button",
      elemToggleVisibility: ".cityInterventionsBlock__body",
      elemToggleTitle: ".cityInterventionsBlock__title"
    }

    this.options = Object.assign({}, defaults, options);

    //auto init
    this.init();

  }

  init() {
    this._listenDispatcher();
  }

  _listenDispatcher() {

    $(this.options.elemDispatcher).on('click touchend', function(evt) {
      evt.preventDefault();

      $(this.options.elemDispatcher).slideUp();
      $(this.options.elemToggleVisibility).slideToggle();


    }.bind(this));

    $(this.options.elemToggleTitle).on('click touchend', function(evt) {
      evt.preventDefault();
     
      $(this.options.elemToggleVisibility).slideToggle();
      $(this.options.elemDispatcher).show();


    }.bind(this));
  }
}
